/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_my_account = /** @type {(inputs: {}) => string} */ () => {
	return `Můj účet`
};

const da_my_account = /** @type {(inputs: {}) => string} */ () => {
	return `Min konto`
};

const de_my_account = /** @type {(inputs: {}) => string} */ () => {
	return `Mein Konto`
};

const en_my_account = /** @type {(inputs: {}) => string} */ () => {
	return `My account`
};

const es_my_account = /** @type {(inputs: {}) => string} */ () => {
	return `Mi cuenta`
};

const fr_my_account = /** @type {(inputs: {}) => string} */ () => {
	return `Mon compte`
};

const hu_my_account = /** @type {(inputs: {}) => string} */ () => {
	return `Saját fiók`
};

const it_my_account = /** @type {(inputs: {}) => string} */ () => {
	return `Il mio account`
};

const nl_my_account = /** @type {(inputs: {}) => string} */ () => {
	return `Mijn account`
};

const pl_my_account = /** @type {(inputs: {}) => string} */ () => {
	return `Moje konto`
};

const pt_my_account = /** @type {(inputs: {}) => string} */ () => {
	return `Minha conta`
};

const sv_my_account = /** @type {(inputs: {}) => string} */ () => {
	return `Mitt konto`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const my_account = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.my_account(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("my_account", locale)
	if (locale === "cs") return cs_my_account(inputs)
	if (locale === "da") return da_my_account(inputs)
	if (locale === "de") return de_my_account(inputs)
	if (locale === "en") return en_my_account(inputs)
	if (locale === "es") return es_my_account(inputs)
	if (locale === "fr") return fr_my_account(inputs)
	if (locale === "hu") return hu_my_account(inputs)
	if (locale === "it") return it_my_account(inputs)
	if (locale === "nl") return nl_my_account(inputs)
	if (locale === "pl") return pl_my_account(inputs)
	if (locale === "pt") return pt_my_account(inputs)
	return sv_my_account(inputs)
};